import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    ChangesHistoryGetListParams,
    ChangesHistoryGetListResponseT,
    HistoryTypesGetListResponseT,
} from '../types/changes_history.types'

export class ChangesHistoryRepository {
    getList(
        page: number,
        params?: ChangesHistoryGetListParams
    ): Promise<AxiosResponse<ChangesHistoryGetListResponseT>> {
        return http.get('/analytics/api/history', {
            params: { page, ...params },
        })
    }

    getHistoryTypes(): Promise<AxiosResponse<HistoryTypesGetListResponseT>> {
        return http.get('/analytics/api/history-type')
    }
}
